<template>
    <span
        class="date-cell"
        :data-test-id="dataTestId"
    >
        {{ formattedValue }}
    </span>
</template>

<script>
import EMPTY_LABEL from './empty-label'

const DATE_FORMAT = 'YYYY-MM-DD'
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'

export default {
    name: 'DateCell',

    props: {
        dataTestId: {
            type: String,
            required: true,
        },
        showTime: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
    },

    computed: {
        formattedValue() {
            const localDate = window.moment.utc(this.value).local()

            if (!localDate.isValid()) {
                return EMPTY_LABEL
            }

            return localDate.format(this.showTime ? DATE_TIME_FORMAT : DATE_FORMAT)
        },
    },
}
</script>

<style lang="scss" scoped>
.date-cell {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
